import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Flex, { ALIGN_CLASS, DIRECTION_CLASS, GAP_CLASS } from "components/Flex";
import {
  SUBTITLE,
  TITLE,
} from "components/ProposalSectionsAssignment/constants";
import { modalTypes } from "constants/types";
import { arrayOf, number, shape, string } from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import {
  exportProposalSectionsAssignmentCsv,
  exportProposalSectionsAssignmentPdf,
} from "slices/proposalDashboard/proposalSectionsAssignment";

import styles from "./ProposalSectionsAssignmentModal.module.scss";

const ProposalSectionsAssignmentModal = ({ data }) => {
  const dispatch = useDispatch();

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.PROPOSAL_SECTIONS_ASSIGNMENT));
  };

  const { allPeople = [] } = data;

  const maxCount = Math.max(
    ...allPeople.map((person) => person.sectionCount),
    1
  );

  return (
    <Modal
      backdrop
      centered
      className={`fade-in ${styles.modal}`}
      onDismiss={onDismiss}
      show
      size="lg"
    >
      <Modal.Header>{TITLE}</Modal.Header>
      <Modal.Body>
        <Flex
          alignItems={ALIGN_CLASS.stretch}
          direction={DIRECTION_CLASS.column}
          gap={GAP_CLASS.GAP_400}
          className={styles.proposalSectionsAssignmentModal}
        >
          <p className={styles.proposalSectionsAssignmentModal__subtitle}>
            {SUBTITLE}
          </p>
          <Flex
            direction={DIRECTION_CLASS.column}
            gap={GAP_CLASS.GAP_300}
            alignItems={ALIGN_CLASS.stretch}
            className={styles.proposalSectionsAssignmentModal__list}
          >
            {allPeople.map((person) => (
              <Flex
                key={person.displayName}
                direction={DIRECTION_CLASS.column}
                gap={GAP_CLASS.GAP_100}
                alignItems={ALIGN_CLASS.stretch}
              >
                <p
                  className={styles.proposalSectionsAssignmentModal__personName}
                >
                  {person.displayName}
                </p>
                <div
                  className={styles.proposalSectionsAssignmentModal__barWrapper}
                >
                  <Flex
                    className={styles.proposalSectionsAssignmentModal__bar}
                    alignItems={ALIGN_CLASS.center}
                    style={{
                      width: `${(person.sectionCount / maxCount) * 100}%`,
                    }}
                  >
                    <span
                      className={styles.proposalSectionsAssignmentModal__count}
                    >
                      {person.sectionCount}
                    </span>
                  </Flex>
                </div>
              </Flex>
            ))}
          </Flex>
          <Flex justifyContent="flex-end" gap={GAP_CLASS.GAP_200}>
            <NewButton
              onClick={() => dispatch(exportProposalSectionsAssignmentCsv())}
              variant={NewButtonVariant.l2}
            >
              Export CSV
            </NewButton>
            <NewButton
              onClick={() => dispatch(exportProposalSectionsAssignmentPdf())}
              variant={NewButtonVariant.l1}
            >
              Export PDF
            </NewButton>
          </Flex>
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

ProposalSectionsAssignmentModal.propTypes = {
  data: shape({
    allPeople: arrayOf(
      shape({
        displayName: string.isRequired,
        sectionCount: number.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default ProposalSectionsAssignmentModal;
